/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UnlinkSalesforceOpportunityInput = {|
  projectId?: ?string,
  opportunityId?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type UnlinkSalesforceOpportunityMutationVariables = {|
  input: UnlinkSalesforceOpportunityInput
|};
export type UnlinkSalesforceOpportunityMutationResponse = {|
  +unlinkSalesforceOpportunity: ?{|
    +project: ?{|
      +salesforceOpportunity: ?string
    |}
  |}
|};
export type UnlinkSalesforceOpportunityMutation = {|
  variables: UnlinkSalesforceOpportunityMutationVariables,
  response: UnlinkSalesforceOpportunityMutationResponse,
|};
*/


/*
mutation UnlinkSalesforceOpportunityMutation(
  $input: UnlinkSalesforceOpportunityInput!
) {
  unlinkSalesforceOpportunity(input: $input) {
    project {
      salesforceOpportunity
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UnlinkSalesforceOpportunityInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesforceOpportunity",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnlinkSalesforceOpportunityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkSalesforceOpportunityPayload",
        "kind": "LinkedField",
        "name": "unlinkSalesforceOpportunity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnlinkSalesforceOpportunityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UnlinkSalesforceOpportunityPayload",
        "kind": "LinkedField",
        "name": "unlinkSalesforceOpportunity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UnlinkSalesforceOpportunityMutation",
    "operationKind": "mutation",
    "text": "mutation UnlinkSalesforceOpportunityMutation(\n  $input: UnlinkSalesforceOpportunityInput!\n) {\n  unlinkSalesforceOpportunity(input: $input) {\n    project {\n      salesforceOpportunity\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3239137bda25997b25cf6f831fb2d5de';

module.exports = node;
